import React, {lazy} from 'react';
import {Route, Routes, useParams, useMatch} from "react-router-dom";
import HomePage from "./pages/HomePage";
import OpenIssues from "./components/reportIssue/OpenIssues";
import Logout from "./components/auth/Logout";
import TrustedDevices from "./components/auth/TrustedDevices";
import ClosedIssues from "./components/reportIssue/ClosedIssues";
import DigitalSignageGroups from "./components/digitalsignage/Groups";
import DigitalSignageConfiguration from "./components/digitalsignage/Configuration";
import {modules} from "./utils/menu";
import Mustering from "./components/mustering/Mustering";
import ThermalScans from "./components/thermal/ThermalScans";
import ThermalReport from "./components/thermal/ThermalReport";
import Groups from "./components/cabinmessages/Groups";
import Messages from "./components/cabinmessages/Messages";
import ExcursionBookings from './components/excursions/ExcursionBookings';
import OnboardTV from './components/onboarddevices/OnboardTV';
import ExternalEvents from './components/externalevents/ExternalEvents';
import Concierge from './components/concierge/Concierge';
import { useUserContext } from './context/UserContext';

function AppRoutes(props) {
    console.log("routes here");
    return (
        <div>
            <Routes>
                <Route path="/digitalsignage/groups" element={<DigitalSignageGroups />} />
                <Route path="/digitalsignage/configuration" element={<DigitalSignageConfiguration />} />
                <Route path="/whoami" element={<AboutMe />} />
                <Route path="/problems/closed" element={<ClosedIssues />} />
                <Route path="/problems/open" element={<OpenIssues />} />
                <Route path="/concierge" element={<Concierge />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/profile/logout" element={<Logout />} />
                <Route path="/profile/trustedDevices" element={<TrustedDevices />} />
                <Route path="/mustering/:type?" element={<Mustering />} />
                <Route path="/thermal/scans" element={<ThermalScans />} />
                <Route path="/thermal/report" element={<ThermalReport />} />

                <Route path="/cabinmessages/groups" element={<Groups />} />

                <Route path="/cabinmessages/messages" element={<Messages />} />

                <Route path="/excursions" element={<ExcursionBookings />} />

                <Route path="/external-events" element={<ExternalEvents />} />

                <Route path="/onboardtv" element={<OnboardTV />}/>

                <Route path="/" element={<HomePage />} />

                {/* dynamic routes based on modules */}
                {Object.keys(modules).map(module =>
                    <Route key={module} path={"/" + module.toLowerCase()} element={<ModuleRoute module={module}/>} />
                )}

                <Route path="*" element={<NoRoute />} />
            </Routes>
        </div>
    );
}

export default AppRoutes;

function ModuleRoute(props) {
    const { path } = useMatch();
    console.log("module route", path, props);
    return (
        <Routes>
            <Route path={`${path}/:page/:hubId`} element={<PageRoute module={props.module}/>} />
        </Routes>
    );
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function PageRoute(props) {
    const {page, hubId} = useParams();

    const PageComponent = lazy(() => import(`./components/dynamic/${props.module.toLowerCase()}/${capitalizeFirstLetter(page)}`).catch(() =>
        import(`./components/dynamic/MissingComponent`)
    ));

    return (
        <div>
            <div className="text-2xl">
                This is a page
            </div>
            <div>
                module: {props.module}
            </div>
            <div>
                page: {page}
            </div>
            <div>
                hubId: {hubId}
            </div>

            <div>
                <React.Suspense fallback="Loading components...">
                    <PageComponent />
                </React.Suspense>
            </div>
        </div>
    )
}


function AboutMe() {
    const {user: {info: user}} = useUserContext();
    return(
        <div>
            <div>Name: {user.sessionName}</div>
            <div>session id: {user.sessionId}</div>
            <div>session type: {user.sessionType}</div>

        </div>
    )
}



const NoRoute = () => {
    return(
        <div>
            No match in router
        </div>
    )
}